import EntityValidationResult from 'modules/base/dto/validation/EntityValidationResult';
import UserEditDto from 'app/admin/user/dto/UserEditDto';
import nBossConnection from 'modules/base/service/nBossConnection';
import NamedDto from 'modules/base/dto/NamedDto';

class UserService {
	constructor() {
		this.connection = nBossConnection.connection;
		this.CONTROL = 'userControl';
	}

	/**
	* @param {string} email
	* @return {Promise<EntityValidationResult>}
	*/
	requestPasswordReset(email) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/requestPasswordReset`, { email })
				.then(response => resolve(new EntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	* @param {string} token
	* @param {string} newPassword
	* @param {string} newPasswordAgain
	* @return {Promise<EntityValidationResult>}
	*/
	resetPassword(token, newPassword, newPasswordAgain) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/resetPassword`, { token, newPassword, newPasswordAgain })
				.then(response => resolve(new EntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}
}

export default new UserService();